import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { contactService } from "../../../base/contactService";
import { contacts, contactwindowDetails, initialStateModel, profileDetails } from "../../../models/model";
import { HighlightInner } from "../rightsidebar/highlight";
import styles from "./scss/contactlist.module.scss";
import noResult from "../../../styles/images/empty_states/empty-nofound.svg";
import NoContent from "../../../shared/widgets/noContent";
import { URChatLeftSkeleton } from "../../../shared/skeletonLoading/chatLeftSkeleton";
import _ from "lodash";
import { Tooltip } from 'antd';
import ProfileAvatarGroup from "../../chat/leftsidebar/profileavatargroup";
import meetingsvg from "../../../styles/images/meetingsvg.svg";
import sicksvg from "../../../styles/images/sick_status.svg";
import traveling from "../../../styles/images/Traveling_status.svg";
import vacation from "../../../styles/images/vacation_status.svg";
import workingRemotely from "../../../styles/images/working_remotely_status.svg";
import store from "../../../context/store/store";
type contactprops ={
  defaultContacts:any;
}
type  contactTopState = {
  updownCount:number;
  totalCount:number;
}
function ContactLists({defaultContacts}:contactprops) {
  const contactList: contacts = useSelector((state: initialStateModel) => state.contactReducer);
  const {contactWindowDetails }:contactwindowDetails  = useSelector((state:initialStateModel)=> state.contactWindowReducer)
  let { scrollContactLinkList }: any = store.getState().contactWindowReducer;
 // const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const [topInfo, settopInfo] = useState<contactTopState>({updownCount:0,totalCount:0
  });
  //const [contactLists, setcontactLists] = useState<any>([]);

  const selectedContactRef: any = useRef(null);
  useEffect(() => {
    var focusableInputElements:any = document.querySelectorAll("#tranTextd");
    settopInfo({...topInfo ,
      totalCount:focusableInputElements.length});
    // if(defaultContacts.isFilter === true || defaultContacts.isSearch === true){
    //   setcontactLists(defaultContacts.searchContacts);
    // }
    // else{
    //   setcontactLists(contactList.allContacs);
    // }

// for (var ind = 0; ind < focusableInputElements.length; ind++) {
//   (function(ind) {
//     focusableInputElements[ind].addEventListener('click', function() {
//       focusableInputElements[topInfo.updownCount].style.backgroundColor = "";
//       focusableInputElements[topInfo.updownCount].style.borderBottom = "";
//       focusableInputElements[ind].focus();
//       focusableInputElements[ind].style.backgroundColor = "#B3D7FA";
//       focusableInputElements[ind].style.border  = "#D9EBFD";
//       focusableInputElements[ind].style.outline  = "none";
//       settopInfo({...topInfo ,
//         updownCount:ind});
//     });
//   })(ind);
// }
    // return ()=>{
    //   setcontactLists(defaultContacts.searchContacts);
    // };

  }, [defaultContacts.searchContacts?.length]);
    
  document.onkeydown = function(e: any) {
    if(e.keyCode === 38){
      upArrow(e);
    } else  if(e.keyCode === 40){
      downArrow(e);
    } else  if(e.keyCode === 13){
     let details =  defaultContacts?.listContacts[topInfo.updownCount];
     openContactWindow(details);
    }
  }

const upArrow = (e:any)=>{
  let downCountRes:number = topInfo.updownCount - 1;
  if(topInfo.updownCount !== 0){
    var focusableInputElements:any = document.querySelectorAll("#tranTextd");
    let nextIndex = downCountRes;
    e.preventDefault();
    nextIndex= downCountRes;
    focusableInputElements[nextIndex].focus();
    focusableInputElements[nextIndex].style.backgroundColor = "#B3D7FA";
    focusableInputElements[nextIndex].style.borderBottom = "1px solid #68AFF5";
    focusableInputElements[nextIndex].style.outline  = "none";
    focusableInputElements[nextIndex + 1].style.backgroundColor = "";
    focusableInputElements[nextIndex + 1].style.borderBottom = "";
    settopInfo({...topInfo ,
      updownCount:downCountRes});
  }
};
const downArrow = (e:any)=>{
  let downCountRes:number = topInfo.updownCount + 1;
  if(downCountRes < topInfo.totalCount){
    var focusableInputElements:any = document.querySelectorAll("#tranTextd");
    
    let nextIndex = downCountRes;
     e.preventDefault();
    nextIndex= downCountRes;
   
    if(focusableInputElements.length >0){
    focusableInputElements[nextIndex].focus();
    focusableInputElements[nextIndex].style.backgroundColor = "#B3D7FA";
    focusableInputElements[nextIndex].style.border  = "#D9EBFD";
    focusableInputElements[nextIndex].style.outline  = "none";
    focusableInputElements[nextIndex - 1].style.backgroundColor = "";
    focusableInputElements[nextIndex - 1].style.borderBottom = "";
    }
    settopInfo({...topInfo ,
      updownCount:downCountRes});
  }
};
  const openContactWindow = (contactDetails:any, index?:number)=>{
    contactService.openContactWindow(contactDetails,index);
   
  };


useEffect(()=>{
  if (selectedContactRef.current) {
    selectedContactRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }
}, [scrollContactLinkList])

   //var len = Math.round((defaultContacts.listContacts?.length / 8));
   var len = Array.isArray(defaultContacts.listContacts) && defaultContacts.listContacts?.length > 7 ? Math.ceil((defaultContacts.listContacts?.length / 8)) : 1;
   var random_color = Array(len).fill([1,2,3,4,5,6,7,8]).flat();
  
  return (
    <>
        { ((!contactList.allContacsLoading || contactList.allContacs?.length===0 || defaultContacts.isLoading === false))  ? ([1, 2, 3, 4, 5,6,7,8,9,10,11,12,13,14,15].map((item: any, index: any) => (
        <URChatLeftSkeleton width={100} key={index} />
      ))):null
      }
      { defaultContacts?.searchContacts &&   defaultContacts?.searchContacts?.map((list:any,i:any)=>{
        
        return ( <div className={styles.profilelists} key={i}>
          <p className={styles.listgrouptag}>{list.group}</p>
          {
            list.ContactList.map((list:any,index:any)=>{
              let nameLength:any =list?.team_name ? list?.team_name : list?.caller_id
              let contactDetailId = contactWindowDetails?.sip_login_id ?? contactWindowDetails?.team_id;
              let listActive = list.sip_login_id ?? list.team_id;
              let fullIndex = _.findIndex(defaultContacts?.listContacts, function (res: any) {
                 return (res?.team_id? res?.team_id === defaultContacts?.searchContacts[i]?.ContactList[0]?.team_id :res?.sip_login_id === defaultContacts?.searchContacts[i]?.ContactList[0]?.sip_login_id);
              });
             
              let resIndex =  i === 0 ? index: (fullIndex +index+1);
              return (<>
                {list.team_members !== null&&
          <div className={  !_.isUndefined(contactDetailId) && listActive===contactDetailId  ? `${styles.profilelisthover } ${styles.active}` :   styles.profilelisthover  }  ref={listActive === contactDetailId ? selectedContactRef : null} key={index}>

             <div className={styles.profileinners} onClick={()=> openContactWindow(list,resIndex)}  key={index} id="tranTextd" tabIndex={index}>
             <ProfileAvatarGroup  key={index} contactDetail={list } profileSize={28} randomColor={random_color[resIndex]} plusContent={1}></ProfileAvatarGroup>
              <div className={styles.middle} >
              {nameLength?.length > 15 && <Tooltip overlayClassName="tooltiplftsizesm" mouseEnterDelay={1.0} placement="top" 
              title={list?.team_name ? list?.team_name : list?.caller_id}>
         
                <h4 ><HighlightInner content={list?.team_name ? list?.team_name : list?.caller_id}
                  searchedData={defaultContacts.searchText}></HighlightInner></h4>
                  <p className={styles.secondRow}><img className={styles.statusimg} src={(list?.status_msg === "In a Meeting" || list?.status_msg === "In a meeting" ) ? meetingsvg : list?.status_msg === "Sick" ? sicksvg : list?.status_msg === "Travelling" ? traveling :list?.status_msg === "On Vacation" ? vacation :(list?.status_msg === " Working remotely " ||list?.status_msg === "Working Remotely" ||list?.status_msg === "Working remotely" ) ? workingRemotely : "" } alt="" />{list?.status_msg } </p>
            </Tooltip>}
            {nameLength?.length<=15  && 
            <><h4><HighlightInner content={list?.team_name ? list?.team_name : list?.caller_id}
                          searchedData={defaultContacts.searchText}></HighlightInner></h4>
                          <p className={styles.secondRow}>
                            <img className={styles.statusimg} src={(list?.status_msg === "In a Meeting" || list?.status_msg === "In a meeting" ) ? meetingsvg : list?.status_msg === "Sick" ? sicksvg : list?.status_msg === "Travelling" ? traveling :list?.status_msg === "On Vacation" ?vacation : (list?.status_msg === " Working remotely " ||list?.status_msg === "Working remotely" ||list?.status_msg === "Working Remotely" ) ? workingRemotely : "" } alt="" />{ list?.status_msg }</p></>
            }
              </div>
              <div className={styles.rights}>
                <HighlightInner content={"team_id_prefix" in list ? '': list["ext"]?.toString()}
                  searchedData={defaultContacts.searchText}></HighlightInner>
               </div>
            </div>
              </div>
            }
            </>);
            })
          }
            
          
         
        </div>);
          
      })}
      {(defaultContacts?.searchContacts.length === 0 && defaultContacts.isSearch === true) && contactList.allContacsLoading === true && contactList.allContacs?.length>0 &&
        <NoContent image={noResult}
              title={''}
              description={'No results found'} />}
      

    </>
  );
};
export default React.memo(ContactLists)